import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScrollViewModule } from '../scroll-view/scroll-view.module';
import {
  ListComponent,
  ListContainerTemplate,
  ListEmptyTemplate,
  ListItemTemplate,
} from './list.component';

const declarations = [
  ListComponent,
  ListItemTemplate,
  ListContainerTemplate,
  ListEmptyTemplate,
];

@NgModule({
  imports: [CommonModule, ScrollViewModule],
  declarations,
  exports: declarations,
})
export class ListModule {}
